import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-drawer',
  templateUrl: './app-drawer.component.html',
  styleUrl: './app-drawer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppDrawerComponent implements OnInit, OnDestroy {
  @Input() public isOpen: boolean = false;
  @Input() public title: string = '';
  @Input() public width: string = '50vw';
  @Input() public minWidth: string = '600px';
  @Input() public maxWidth: string = '100vw';
  @Input() public closeOnBackdrop: boolean = true;
  @Input() public showBackdrop: boolean = true;
  @Output() public closed = new EventEmitter<void>();

  private removeKeydownListener: (() => void) | null = null;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    public readonly translocoService: TranslocoService,
  ) {}

  ngOnInit(): void {
    const handleKeydown = (event: KeyboardEvent): void => {
      if (!this.isOpen || event.key !== 'Escape') {
        return;
      }

      this.onClose();
    };

    this.document.addEventListener('keydown', handleKeydown, true);
    this.removeKeydownListener = () => {
      this.document.removeEventListener('keydown', handleKeydown, true);
    };
  }

  ngOnDestroy(): void {
    this.removeKeydownListener?.();
    this.removeKeydownListener = null;
  }

  public onClose(): void {
    this.closed.emit();
  }

  public onBackdropClick(): void {
    if (this.closeOnBackdrop) {
      this.closed.emit();
    }
  }
}
